export default __webpack_public_path__ + "static/media/Circe-Bold.3829a43c.otf";